import GaEvent from './GaEvent';

export default class ContentItemDetailsViewedGaEvent extends GaEvent {
  constructor(slug: string) {
    super('content_item_details_viewed');

    this.addPageSlug(slug);
  }
}
